import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth, hasAnyRole } from './AuthContext'
import { homePathForRoles, isStaffRoles } from './roles'
import { salonPublicPath, salonSlugFromPath } from '../lib/salonSiteUrls'
import { useTranslation } from 'react-i18next'

export function ProtectedRoute({ roles }: { roles?: string[] }) {
  const { user, loading } = useAuth()
  const { t } = useTranslation()
  const location = useLocation()

  if (loading) {
    return (
      <div className="container" style={{ padding: '3rem 0' }}>
        <div className="skeleton" style={{ height: 24, width: 180 }} />
        <p>{t('common.loading')}</p>
      </div>
    )
  }

  if (!user) {
    const nextRaw = `${location.pathname}${location.search}`
    const tenant = salonSlugFromPath(location.pathname)
    const loginTo = tenant
      ? `${salonPublicPath(tenant, 'login')}?next=${encodeURIComponent(nextRaw)}`
      : `/login?next=${encodeURIComponent(nextRaw)}`
    return <Navigate to={loginTo} replace />
  }

  if (roles && !hasAnyRole(user, roles)) {
    // Wrong area for this role → send them to their own home (admin dashboard / Mein Bereich).
    return <Navigate to={homePathForRoles(user.roles)} replace />
  }

  // Staff opening /account should land on their dashboard instead.
  if (location.pathname.startsWith('/account') && isStaffRoles(user.roles)) {
    return <Navigate to={homePathForRoles(user.roles)} replace />
  }

  return <Outlet />
}
